module.exports = __webpack_public_path__ + "assets/a1caf97b6d89b556048d0046ea22347e.icon_update_sent.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./app/src/styles/images/icon_update_sent.svg
 ** module id = 200
 ** module chunks = 1
 **/